import { Field, useFormikContext } from "formik";
import FilterBenutzerSelect from "../benutzer/FilterBenutzerSelect";
import { TextField } from "formik-mui";
import React, { useEffect, useState } from "react";
import { useGetBenutzer } from "../../client/hooks";
import { useQuery } from "react-query";

export default function AzSaldoFields({
  mitarbeiterIdProp,
}: {
  mitarbeiterIdProp?: string;
}) {
  const [mitarbeiterId, setMitarbeiterId] = React.useState<string>(
    mitarbeiterIdProp || ""
  );
  const ladeBenutzer = useGetBenutzer();
  const { data: benutzerData } = useQuery(
    ["azsaldo", mitarbeiterId],
    () => ladeBenutzer(mitarbeiterId as string),
    {
      enabled:
        !!mitarbeiterId && mitarbeiterId !== "_all" && mitarbeiterId !== "",
      refetchOnWindowFocus: false,
    }
  );
  const { setFieldValue } = useFormikContext();
  useEffect(() => {
    if (mitarbeiterId) {
      if (benutzerData && benutzerData.azSaldo !== undefined) {
        const saldo = benutzerData.azSaldo;
        setFieldValue("azSaldo", saldo);
      } else {
        setFieldValue("azSaldo", 0);
      }
    }
  }, [benutzerData, mitarbeiterId, setFieldValue]);
  return (
    <>
      <Field
        component={FilterBenutzerSelect}
        name={"mitarbeiterId"}
        label={"Mitarbeiter *"}
        setBenutzer={(value: string) => {
          setMitarbeiterId(value);
        }}
      />
      <Field
        component={TextField}
        name="azSaldo"
        label="Az-Saldo"
        type="number"
        fullWidth
        margin="normal"
      />
    </>
  );
}
